import React, { FC } from 'react';
import { useMe, Skeleton, PageHeading, MailToLink } from 'src/common';
import styles from './index.module.scss';
import { useTranslation } from 'react-i18next';
import { faCommentsQuestionCheck } from '@fortawesome/pro-light-svg-icons';
import { FeatureFlag, useFeatureFlag } from 'src/helpers/featureFlag';
import BiddingGPTFiles from './BiddingGPTFiles';

export const BiddingGPTPage: FC = () => {
  const { data: meData } = useMe();
  const companyId = meData?.company.id;
  const { t } = useTranslation();
  const isBiddingGPTCSVFeature = useFeatureFlag(FeatureFlag.BiddingTool_BiddingGPT_CSV);

  return companyId === undefined ? (
    <Skeleton active loading />
  ) : (
    <div className={styles.container}>
      <PageHeading
        title={t('Navigation.biddingGPT')}
        icon={faCommentsQuestionCheck}
        desc={
          <div>
            <h5 className={styles.descTitle}>{t('BiddingGPT.biddingGPTDesc1')}</h5>
            <p>{t('BiddingGPT.biddingGPTDesc2')}</p>
            <h5 className={styles.descTitle}>{t('BiddingGPT.biddingGPTDesc3')}</h5>
            <p>{t('BiddingGPT.biddingGPTDesc4')}</p>
          </div>
        }
      />
      <MailToLink
        title={t('BiddingGPT.biddingGPTContact')}
        email="support@tendium.com"
        subject={t('BiddingGPT.biddingGPTEmailSubject')}
        body={t('BiddingGPT.biddingGPTEmailBody')}
      />
      {isBiddingGPTCSVFeature && <BiddingGPTFiles />}
    </div>
  );
};

export default BiddingGPTPage;
